import * as Crypto from "./crypto";
import * as lodash from "./lodash";

export const CryptoJS = Crypto;
export const _ = lodash;
